import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  container: {
    flexDirection: "column",
    maxWidth: "1200px",
    margin: "20px",
  },
});
